import johnwood from "./assets/IMG_0555.JPG";
import stephen from "./assets/IMG_0553.JPG";
import keith from "./assets/IMG_0554.JPG";
import norman from "./assets/IMG_0556.JPG";
import ron from "./assets/IMG_0557.JPG";
import newman from "./assets/IMG_0558.JPG";
import Pic from "./assets/IMG_0537.JPG";
import Pic2 from "./assets/IMG_0540.JPG";
import Pic3 from "./assets/IMG_0538.JPG";
import av1 from "./assets/av1.JPG";
import av2 from "./assets/av2.JPG";
import av3 from "./assets/av3.JPG";
import av4 from "./assets/av4.JPG";
import av5 from "./assets/av5.JPG";
import av6 from "./assets/av6.JPG";

export const data = {
  Blog: [
    {
      title: "Blog 1",
      author: "Brad Sagraves",
      image: Pic,
      content: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente
    recusandae eius beatae, explicabo, enim delectus accusantium rem
    neque quisquam, alias quas. `
    },
    {
      title: "Blog 2",
      author: "Ron Hill",
      image: Pic2,
      content: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente
      recusandae eius beatae, explicabo, enim delectus accusantium rem
      neque quisquam, alias quas. `
    },
    {
      title: "Blog 3",
      author: "P. Newman Bankston",
      image: Pic3,
      content: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente
      recusandae eius beatae, explicabo, enim delectus accusantium rem
      neque quisquam, alias quas. `
    }
  ],
  Attorneys: {
    johnWood: {
      name: "John Wood",
      practice_areas: { business: "Business and Stuff" },
      email: "John@email.com",
      image: johnwood,
      image: av5,
      profile_url: "/people/johnWood"
    },
    ronHill: {
      name: "Ron T. Hill",
      bio: `Since 1984, Ron has practiced in the above listed areas across the
      state of Tennessee. Before beginning law practice, Ron worked in
      the insurance and risk management industry for 11 years. Ron is a
      member of the Knoxville and Tennessee Bar Associations. Among
      other charitable work, he provides pro bono services to multiple
      private, Christian organizations.`,
      practice_areas: {
        business: "Business and Stuff",
        taxation: "Taxation and Stuff",
        commercial: "Commercial and Stuff"
      },
      contact_info: [
        { name: "email", value: "Ron@Ron.com" },
        { name: "phone", value: "865-546-0500" },
        { name: "fax", value: "865-525-5293" }
      ],
      image: av1,
      profile_url: "/people/ronHill",
      education: [
        `J.D., Memphis State University, 1984`,
        `B.A., Memphis State University, 1973`
      ],
      admissions: [
        `Tennessee, 1985`,
        `U.S. District Court, Eastern District of Tennessee`,
        `U.S. District Court, Western District of Tennessee`,
        `U.S. Court of Appeals, Sixth Circuit`,
        `U.S. Supreme Court`
      ],
      distinctions: [
        `Chancellor, Sigma Delta Kappa`,
        `Tennessee Supreme Court Rule 31 Listed mediator`
      ]
    },
    newmanBankston: {
      name: "P. Newman Bankston",
      practice_areas: ["Business"],
      email: "Newman@email.com",
      image: av2,

      profile_url: "/people/newmanBankston"
    },
    keithBurrows: {
      name: "Keith Burroughs",
      practice_areas: { business: "Business and Stuff" },
      email: "Keith@email.com",
      image: av4,
      profile_url: "/people/keithBurrows"
    },
    normanTempleton: {
      name: "Norman Templeton",
      practice_areas: { business: "Business and Stuff" },
      email: "Norm@email.com",
      image: av6,
      profile_url: "/people/normanTempleton"
    },
    stephenMcsween: {
      name: "Stephen McSween",
      practice_areas: { business: "Business and Stuff" },
      email: "Stephen@email.com",
      image: av3,
      profile_url: "/people/stephenMcsween"
    },
    johnWood5: {
      name: "John Wood",
      practice_areas: { business: "Business and Stuff" },
      email: "John@email.com",
      image: johnwood,
      image: av5,
      profile_url: "/people/johnWood"
    },
    ronHill5: {
      name: "Ron T. Hill",
      bio: `Since 1984, Ron has practiced in the above listed areas across the
      state of Tennessee. Before beginning law practice, Ron worked in
      the insurance and risk management industry for 11 years. Ron is a
      member of the Knoxville and Tennessee Bar Associations. Among
      other charitable work, he provides pro bono services to multiple
      private, Christian organizations.`,
      practice_areas: {
        business: "Business and Stuff",
        taxation: "Taxation and Stuff",
        commercial: "Commercial and Stuff"
      },
      contact_info: [
        { name: "email", value: "Ron@Ron.com" },
        { name: "phone", value: "865-546-0500" },
        { name: "fax", value: "865-525-5293" }
      ],
      image: av1,
      profile_url: "/people/ronHill",
      education: [
        `J.D., Memphis State University, 1984`,
        `B.A., Memphis State University, 1973`
      ],
      admissions: [
        `Tennessee, 1985`,
        `U.S. District Court, Eastern District of Tennessee`,
        `U.S. District Court, Western District of Tennessee`,
        `U.S. Court of Appeals, Sixth Circuit`,
        `U.S. Supreme Court`
      ],
      distinctions: [
        `Chancellor, Sigma Delta Kappa`,
        `Tennessee Supreme Court Rule 31 Listed mediator`
      ]
    },
    newmanBankston5: {
      name: "P. Newman Bankston",
      practice_areas: ["Business"],
      email: "Newman@email.com",
      image: av2,

      profile_url: "/people/newmanBankston"
    },
    keithBurrows5: {
      name: "Keith Burroughs",
      practice_areas: { business: "Business and Stuff" },
      email: "Keith@email.com",
      image: av4,
      profile_url: "/people/keithBurrows"
    },
    normanTempleton5: {
      name: "Norman Templeton",
      practice_areas: { business: "Business and Stuff" },
      email: "Norm@email.com",
      image: av6,
      profile_url: "/people/normanTempleton"
    },
    stephenMcsween5: {
      name: "Stephen McSween",
      practice_areas: { business: "Business and Stuff" },
      email: "Stephen@email.com",
      image: av3,
      profile_url: "/people/stephenMcsween"
    },
    johnWood4: {
      name: "John Wood",
      practice_areas: { business: "Business and Stuff" },
      email: "John@email.com",
      image: johnwood,
      image: av5,
      profile_url: "/people/johnWood"
    },
    ronHill4: {
      name: "Ron T. Hill",
      bio: `Since 1984, Ron has practiced in the above listed areas across the
      state of Tennessee. Before beginning law practice, Ron worked in
      the insurance and risk management industry for 11 years. Ron is a
      member of the Knoxville and Tennessee Bar Associations. Among
      other charitable work, he provides pro bono services to multiple
      private, Christian organizations.`,
      practice_areas: {
        business: "Business and Stuff",
        taxation: "Taxation and Stuff",
        commercial: "Commercial and Stuff"
      },
      contact_info: [
        { name: "email", value: "Ron@Ron.com" },
        { name: "phone", value: "865-546-0500" },
        { name: "fax", value: "865-525-5293" }
      ],
      image: av1,
      profile_url: "/people/ronHill",
      education: [
        `J.D., Memphis State University, 1984`,
        `B.A., Memphis State University, 1973`
      ],
      admissions: [
        `Tennessee, 1985`,
        `U.S. District Court, Eastern District of Tennessee`,
        `U.S. District Court, Western District of Tennessee`,
        `U.S. Court of Appeals, Sixth Circuit`,
        `U.S. Supreme Court`
      ],
      distinctions: [
        `Chancellor, Sigma Delta Kappa`,
        `Tennessee Supreme Court Rule 31 Listed mediator`
      ]
    },
    newmanBankston4: {
      name: "P. Newman Bankston",
      practice_areas: ["Business"],
      email: "Newman@email.com",
      image: av2,

      profile_url: "/people/newmanBankston"
    },
    keithBurrows4: {
      name: "Keith Burroughs",
      practice_areas: { business: "Business and Stuff" },
      email: "Keith@email.com",
      image: av4,
      profile_url: "/people/keithBurrows"
    },
    normanTempleton4: {
      name: "Norman Templeton",
      practice_areas: { business: "Business and Stuff" },
      email: "Norm@email.com",
      image: av6,
      profile_url: "/people/normanTempleton"
    },
    stephenMcsween4: {
      name: "Stephen McSween",
      practice_areas: { business: "Business and Stuff" },
      email: "Stephen@email.com",
      image: av3,
      profile_url: "/people/stephenMcsween"
    },
    johnWood3: {
      name: "John Wood",
      practice_areas: { business: "Business and Stuff" },
      email: "John@email.com",
      image: johnwood,
      image: av5,
      profile_url: "/people/johnWood"
    },
    ronHill3: {
      name: "Ron T. Hill",
      bio: `Since 1984, Ron has practiced in the above listed areas across the
      state of Tennessee. Before beginning law practice, Ron worked in
      the insurance and risk management industry for 11 years. Ron is a
      member of the Knoxville and Tennessee Bar Associations. Among
      other charitable work, he provides pro bono services to multiple
      private, Christian organizations.`,
      practice_areas: {
        business: "Business and Stuff",
        taxation: "Taxation and Stuff",
        commercial: "Commercial and Stuff"
      },
      contact_info: [
        { name: "email", value: "Ron@Ron.com" },
        { name: "phone", value: "865-546-0500" },
        { name: "fax", value: "865-525-5293" }
      ],
      image: av1,
      profile_url: "/people/ronHill",
      education: [
        `J.D., Memphis State University, 1984`,
        `B.A., Memphis State University, 1973`
      ],
      admissions: [
        `Tennessee, 1985`,
        `U.S. District Court, Eastern District of Tennessee`,
        `U.S. District Court, Western District of Tennessee`,
        `U.S. Court of Appeals, Sixth Circuit`,
        `U.S. Supreme Court`
      ],
      distinctions: [
        `Chancellor, Sigma Delta Kappa`,
        `Tennessee Supreme Court Rule 31 Listed mediator`
      ]
    },
    newmanBankston3: {
      name: "P. Newman Bankston",
      practice_areas: ["Business"],
      email: "Newman@email.com",
      image: av2,

      profile_url: "/people/newmanBankston"
    },
    keithBurrows3: {
      name: "Keith Burroughs",
      practice_areas: { business: "Business and Stuff" },
      email: "Keith@email.com",
      image: av4,
      profile_url: "/people/keithBurrows"
    },
    normanTempleton3: {
      name: "Norman Templeton",
      practice_areas: { business: "Business and Stuff" },
      email: "Norm@email.com",
      image: av6,
      profile_url: "/people/normanTempleton"
    },
    stephenMcsween3: {
      name: "Stephen McSween",
      practice_areas: { business: "Business and Stuff" },
      email: "Stephen@email.com",
      image: av3,
      profile_url: "/people/stephenMcsween"
    },
    johnWood2: {
      name: "John Wood",
      practice_areas: { business: "Business and Stuff" },
      email: "John@email.com",
      image: johnwood,
      image: av5,
      profile_url: "/people/johnWood"
    },
    ronHill2: {
      name: "Ron T. Hill",
      bio: `Since 1984, Ron has practiced in the above listed areas across the
      state of Tennessee. Before beginning law practice, Ron worked in
      the insurance and risk management industry for 11 years. Ron is a
      member of the Knoxville and Tennessee Bar Associations. Among
      other charitable work, he provides pro bono services to multiple
      private, Christian organizations.`,
      practice_areas: {
        business: "Business and Stuff",
        taxation: "Taxation and Stuff",
        commercial: "Commercial and Stuff"
      },
      contact_info: [
        { name: "email", value: "Ron@Ron.com" },
        { name: "phone", value: "865-546-0500" },
        { name: "fax", value: "865-525-5293" }
      ],
      image: av1,
      profile_url: "/people/ronHill",
      education: [
        `J.D., Memphis State University, 1984`,
        `B.A., Memphis State University, 1973`
      ],
      admissions: [
        `Tennessee, 1985`,
        `U.S. District Court, Eastern District of Tennessee`,
        `U.S. District Court, Western District of Tennessee`,
        `U.S. Court of Appeals, Sixth Circuit`,
        `U.S. Supreme Court`
      ],
      distinctions: [
        `Chancellor, Sigma Delta Kappa`,
        `Tennessee Supreme Court Rule 31 Listed mediator`
      ]
    },
    newmanBankston2: {
      name: "P. Newman Bankston",
      practice_areas: ["Business"],
      email: "Newman@email.com",
      image: av2,

      profile_url: "/people/newmanBankston"
    },
    keithBurrows2: {
      name: "Keith Burroughs",
      practice_areas: { business: "Business and Stuff" },
      email: "Keith@email.com",
      image: av4,
      profile_url: "/people/keithBurrows"
    },
    normanTempleton2: {
      name: "Norman Templeton",
      practice_areas: { business: "Business and Stuff" },
      email: "Norm@email.com",
      image: av6,
      profile_url: "/people/normanTempleton"
    },
    stephenMcsween2: {
      name: "Stephen McSween",
      practice_areas: { business: "Business and Stuff" },
      email: "Stephen@email.com",
      image: av3,
      profile_url: "/people/stephenMcsween"
    },
    johnWood1: {
      name: "John Wood",
      practice_areas: { business: "Business and Stuff" },
      email: "John@email.com",
      image: johnwood,
      image: av5,
      profile_url: "/people/johnWood"
    },
    ronHill1: {
      name: "Ron T. Hill",
      bio: `Since 1984, Ron has practiced in the above listed areas across the
      state of Tennessee. Before beginning law practice, Ron worked in
      the insurance and risk management industry for 11 years. Ron is a
      member of the Knoxville and Tennessee Bar Associations. Among
      other charitable work, he provides pro bono services to multiple
      private, Christian organizations.`,
      practice_areas: {
        business: "Business and Stuff",
        taxation: "Taxation and Stuff",
        commercial: "Commercial and Stuff"
      },
      contact_info: [
        { name: "email", value: "Ron@Ron.com" },
        { name: "phone", value: "865-546-0500" },
        { name: "fax", value: "865-525-5293" }
      ],
      image: av1,
      profile_url: "/people/ronHill",
      education: [
        `J.D., Memphis State University, 1984`,
        `B.A., Memphis State University, 1973`
      ],
      admissions: [
        `Tennessee, 1985`,
        `U.S. District Court, Eastern District of Tennessee`,
        `U.S. District Court, Western District of Tennessee`,
        `U.S. Court of Appeals, Sixth Circuit`,
        `U.S. Supreme Court`
      ],
      distinctions: [
        `Chancellor, Sigma Delta Kappa`,
        `Tennessee Supreme Court Rule 31 Listed mediator`
      ]
    },
    newmanBankston1: {
      name: "P. Newman Bankston",
      practice_areas: ["Business"],
      email: "Newman@email.com",
      image: av2,

      profile_url: "/people/newmanBankston"
    },
    keithBurrows1: {
      name: "Keith Burroughs",
      practice_areas: { business: "Business and Stuff" },
      email: "Keith@email.com",
      image: av4,
      profile_url: "/people/keithBurrows"
    },
    normanTempleton1: {
      name: "Norman Templeton",
      practice_areas: { business: "Business and Stuff" },
      email: "Norm@email.com",
      image: av6,
      profile_url: "/people/normanTempleton"
    },
    stephenMcsween1: {
      name: "Stephen McSween",
      practice_areas: { business: "Business and Stuff" },
      email: "Stephen@email.com",
      image: av3,
      profile_url: "/people/stephenMcsween"
    }
  }
};
export const Practices = {
  taxation: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  estate_planning: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  healthcare: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  technology: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  banking: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  corporate: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  commercial: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  },
  construction: {
    name: "Taxation",
    blurb:
      "The firm offers a substantial amount of expertise in tax planning and representation of clients before the Internal Revenue Service. The tax planning services facilitate the activities of the firm’s transactional practice groups, especially in the areas of mergers and acquisitions, entity formation and corporate finance. The compliance aspects of the practice group include audit and appeals representation, offers-in-compromise and installment payment structures. In addition to transactional support, the firm possesses significant expertise in the formation and operation of tax-exempt entities.",
    subCategories: [
      "Mergers & Acquisitions",
      "Like-kind Exchanges",
      "Federal and State Taxation",
      "Nonprofit/Tax-Exempt Organizations"
    ],
    attorneys: [
      {
        name: "P. Newman Bankston",
        profile_url: "/people/newmanBankston"
      },
      {
        name: "Keith Burrows",
        profile_url: "/people/keithBurrows"
      },
      {
        name: "Norman G. Templeton",
        path: "/people/norman-g-templeton"
      },
      {
        name: "John Wood",
        path: "/people/john-wood"
      }
    ]
  }
};
